import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    configUrl: String,
    currentFileId: String,
    errorMessage: String,
  }

  static targets = ['spreadsheetId', 'fileName', 'submitButton', 'pickButton', 'selectedInfo']

  async pick() {
    this.pickButtonTarget.disabled = true

    try {
      const response = await fetch(this.configUrlValue, {
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
        },
      })

      if (!response.ok) {
        this.pickButtonTarget.disabled = false
        return
      }

      const config = await response.json()

      await this.#loadGoogleApi()
      await this.#loadPicker()

      const view = new google.picker.DocsView(google.picker.ViewId.SPREADSHEETS)
      view.setMimeTypes('application/vnd.google-apps.spreadsheet')

      if (this.hasCurrentFileIdValue && this.currentFileIdValue) {
        view.setFileIds(this.currentFileIdValue)
      }

      const picker = new google.picker.PickerBuilder()
        .addView(view)
        .setOAuthToken(config.access_token)
        .setDeveloperKey(config.api_key)
        .setAppId(config.app_id)
        .setCallback(this.#pickerCallback.bind(this))
        .build()

      picker.setVisible(true)
    } catch {
      // silently fail - picker will just not open
    } finally {
      this.pickButtonTarget.disabled = false
    }
  }

  #pickerCallback(data) {
    if (data.action === google.picker.Action.PICKED) {
      const doc = data.docs[0]
      this.spreadsheetIdTarget.value = doc.id
      this.fileNameTarget.textContent = doc.name

      if (this.hasSelectedInfoTarget) {
        this.selectedInfoTarget.classList.remove('hidden')
      }

      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.disabled = false
      }

      this.currentFileIdValue = doc.id
    }
  }

  #loadGoogleApi() {
    if (window.gapi) return Promise.resolve()

    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://apis.google.com/js/api.js'
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }

  #loadPicker() {
    return new Promise((resolve) => {
      gapi.load('picker', resolve)
    })
  }
}
